"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiCollectionIndexV1 = void 0;
var ApiCollectionIndexV1 = /** @class */ (function () {
    function ApiCollectionIndexV1(config) {
        this._config = config;
    }
    ApiCollectionIndexV1.prototype.getFetchPageUrl = function () {
        return this._config.fetchPageUrl;
    };
    ApiCollectionIndexV1.prototype.fetchPage = function (page, perPage, search, filters) {
        return this._config.http
            .post(this.getFetchPageUrl(), {
            page: page,
            per_page: perPage,
            search: search,
            only_favorited: filters === null || filters === void 0 ? void 0 : filters.onlyFavorited,
        }).then(function (res) {
            if (!res.data) {
                throw new Error('Response data is empty.');
            }
            return res.data;
        });
    };
    return ApiCollectionIndexV1;
}());
exports.ApiCollectionIndexV1 = ApiCollectionIndexV1;
